export default "__VITE_ASSET__8d64c31a__"